<template>
  <div style="width: 1200px">
    <Table border :data="data" :columns="columns">
      <template slot-scope="{ row, index }" slot="action">
        <a style="margin-right: 4px" @click="openList(row)">{{ row.payAmountReal }}</a>
        <a @click="openshifu(row)" type="primary">添加</a>
      </template>
    </Table>
    <form-model title="实付账款" width="400" ref="shifu">
      <Button slot="btn" type="primary" @click="addshifu">提交保存</Button>
    </form-model>
    <Modal title="支出记录" fullscreen v-model="otable" footer-hide>
      <shouzhijilu ref="shouzhijilu"></shouzhijilu>
    </Modal>
  </div>
</template>
<script>
var taizhang = [];
import shouzhijilu from "./shouzhijiluList.vue";
export default {
  props: ["columns", "data"],
  components: { shouzhijilu },
  data() {
    return {
      otable: false,
      item: {
        tallyAccountId: '',
        money: 0,
        ordersChargesId: 0,
        accountDate: Date.now(),
        fileUrl: "",
        fileUrlArr: [],
        voucherType: -1,
      },
      forms: [
        {
          title: "台账",
          key: "tallyAccountId",
          type: "Select",
          selectType: "obj",
          required: true,
          selectItems: taizhang,
          span: 24,
        },
        {
          title: "金额",
          key: "money",
          type: "InputNumber",
          required: true,
          readonly: true,
          span: 24,
        },
        {
          title: "到账日期",
          key: "accountDate",
          type: "lyyymmdd",
          required: true,
          span: 24,
        },
        {
          title: "附件",
          key: "fileUrlArr",
          type: "lyPhoto",

          span: 24,
        },
      ],
      searchItem: {
        pageNumber: 1,
        keyWork: "",
        pageSize: 100,
      },
    };
  },
  methods: {
    openshifu(row) {
      this.item.ordersChargesId = row.id;
      this.item.money = row.payAmount;
      this.$refs.shifu.reach(this.forms, this.item);
      this.getTaizhang();
    },
    addshifu() {
      //fileUrlArr
      var a = this.$refs.shifu.getItem();
      if (!a) {
        return;
      }
      this.item.fileUrl = this.utils.jsonToStr(this.item.fileUrlArr);

      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-fms/tallyBook/addPayble",
        data: this.item,
      }).then((res) => {
        if (res) {
          this.$refs.shifu.close();
          //this.getList();

          this.$emit("finish", 234);
        }
      });
    },
    getTaizhang() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-fms/tallyAccount/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        var data = res.data.data.dataList;
        taizhang.length = 0;
        for (let i = 0; i < data.length; i++) {
          var obj = {
            id: data[i].id,
            name: data[i].name,
          };
          taizhang.push(obj);
        }
      });
    },
    openList(row) {
      this.otable = true;
      var t = {
        ono: row.ono,
        voucherType: 1,
        id: row.id,
      };
      this.$refs.shouzhijilu.reach(t);
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/wuliu/caiwu/yingfuChildList.vue